module.exports = __webpack_public_path__ + "img/tiron.dd325b03.png";